import { render, staticRenderFns } from "./agentDetailEdit.vue?vue&type=template&id=5b78b828&scoped=true"
import script from "./agentDetailEdit.vue?vue&type=script&lang=js"
export * from "./agentDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./agentDetailEdit.vue?vue&type=style&index=0&id=5b78b828&prod&scoped=true&lang=css"
import style1 from "./agentDetailEdit.vue?vue&type=style&index=1&id=5b78b828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b78b828",
  null
  
)

export default component.exports